import React, { useState } from "react";
import "./cardJournal.scss";

import { withPrefix } from "gatsby";

import ShareModal from "../../molecules/share-modal/shareModal";
import {
  normalizeTwoWords,
  formatImageAlt,
} from "../../../shared/utils/stringUtilities";
import DefaultImage from "../../../assets/images/not-found/icono_horizontal_articulos.jpg";

interface JournalInterface {
  journal: {
    titulo: string;
    origenContenido: string;
    autor: string;
    fechaCreacion: string;
    image: {
      title: string;
      file: {
        fileName: string;
        url: string;
      };
    };
    mmsId: string;
    tipoContenido: string;
    reservationId: string | null;
    isOverdrive: boolean;
  };
  gtmClass: string;
}

const CardJournal = (props: JournalInterface) => {
  const { journal } = props;

  //   const [available, setAvailable] = useState<any>(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imgError, setimgError] = useState(false);

  const handleRedirect = (journal) => {
    window.location.assign(withPrefix(`/libros/detalle/?book=${journal}`));
  };

  const handleErroImage = () => {
    setimgError(true);
  };

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const hrefUrl = journal
    ? `${window.location.origin}/bibliotecas/libros/detalle/?book=${journal.mmsId}`
    : "";

  const handleDate = () => {
    let year = journal.fechaCreacion.slice(0, 4);
    let month = journal.fechaCreacion.slice(4, 6);
    // console.log(
    //   "🚀 ~ file: cardJournal.tsx ~ line 73 ~ handleDate ~ journal.fechaCreacion.slice(4, 6);",
    //   journal.fechaCreacion
    // );
    let day = journal.fechaCreacion.slice(6, journal.fechaCreacion.length);

    let months = {
      "01": "ENE.",
      "02": "FEB.",
      "03": "MAR.",
      "04": "ABR.",
      "05": "MAY.",
      "06": "JUN.",
      "07": "JUL.",
      "08": "AGO.",
      "09": "SEP.",
      "10": "OCT.",
      "11": "NOV",
      "12": "DEC",
    };
    return `${day} DE ${months[month]} DE ${year}`;
  };

  return (
    <div className="a-card-journal">
      {journal && (
        <>
          <div className={`"a-card-journal-content"`}>
            <div
              className="a-card-journal-content-img"
              onClick={() => handleRedirect(journal.mmsId)}
            >
              <img
                src={
                  journal.image
                    ? imgError
                      ? DefaultImage
                      : journal.image.file.url
                    : DefaultImage
                }
                alt={
                  journal.image
                    ? journal.image.title
                      ? formatImageAlt(journal.image.title)
                      : journal.titulo
                    : "Revista comfama"
                }
                onError={handleErroImage}
                className={`gtm${normalizeTwoWords(
                  props.gtmClass
                )}Lectura${normalizeTwoWords(journal.titulo)}`}
              />
            </div>
            <div className="a-card-journal-content__description">
              <span className="a-card-journal-content__description-date">
                {handleDate()}
              </span>
              <a
                className="a-card-journal-content__description-name"
                href={withPrefix(`/libros/detalle/?book=${journal.mmsId}`)}
              >
                {journal.titulo}
              </a>
            </div>
            <span className="a-card-journal-content-separator" />
            <div className="a-card-journal-content-menu">
              <i
                className={`icon icon-share gtm${normalizeTwoWords(
                  props.gtmClass
                )}Lectura${normalizeTwoWords(journal.titulo)}Compartir`}
                onClick={(e) => {
                  toggleModal();
                  e.stopPropagation();
                }}
              />
            </div>
          </div>
          <ShareModal
            open={isModalVisible}
            onClose={toggleModal}
            href={hrefUrl}
          />
        </>
      )}
    </div>
  );
};

export default CardJournal;
